var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-100 bg-light",staticStyle:{"height":"100%","display":"flex","flex-direction":"column"},attrs:{"id":"app"}},[(_vm.showHeader)?_c('AppHeader'):_vm._e(),_c('div',{staticClass:"v-100"},[_c('router-view')],1),_c('AppFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }